module.exports = __webpack_public_path__ + "static/media/ty.9537f0c9.svg";